import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../services/dashboard.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { environment } from '../../environments/environment';

declare const google: any

declare global {
    interface Window {
        google: any;
        initMap: () => void;
    }
}

@Component({
    selector: 'lg-form',
    templateUrl: 'form.component.html',
    styleUrls: ['./form.component.scss']
})

export class FormComponent implements OnInit {

    signInForm: FormGroup;
    userData: any;
    hash: string;
    disableSubmit = false;
    errors: any = '';
    loading = false;
    emailField: any;//abstractControl?
    phoneField: any;//abstractControl?
    
    
	separateDialCode = true;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
    PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [CountryISO.Spain, CountryISO.Portugal];

    constructor(private route: ActivatedRoute, private fb: FormBuilder, public dashboardService: DashboardService, private router: Router) { }

    ngOnInit(): void {
        this.userData = this.route.snapshot.data.data;
        if(this.userData.result=='OK'){
            this.hash = this.route.snapshot.paramMap.get('hash');
            this.initMap()
            this.initForm();
        }else if(this.userData.result=='expired'){
            this.router.navigate(['/410']);
        }else if(this.userData.result=='processed'){
            this.router.navigate(['/204']);
        }else{
            this.router.navigate(['/400']);
        }
    }
    executeChallenge(): void {
        this.disableSubmit = true;
        this.loading = true;
        this.errors = '';
        window.reCaptchaExecute();
    }

    submit = () => {
        const formValue = {
            addresseePhone: this.signInForm.value.phone? this.signInForm.value.phone.e164Number : null,
            addresseeEmail: this.signInForm.value.email,
        }

        this.dashboardService.submitForm(this.hash, formValue).subscribe(res => {
            if (res.success) {
                this.router.navigate(['/success']);
            }else if(res.message){
                alert(res.message);
            }

            window.reCaptchaReset();

            this.errors = res.validationErrors;

            this.disableSubmit = false;
            this.loading = false;
        })
    }

    initForm(): void {
        this.signInForm = this.fb.group({
        });
        const email = this.userData.addresseeEmail || null;
        const phone = this.userData.addresseePhone || null;

        this.signInForm.addControl('email', this.fb.control(email, [Validators.email]));
        this.signInForm.addControl('phone', this.fb.control(phone));

        this.emailField = this.signInForm.get('email');
        this.phoneField = this.signInForm.get('phone');

        if (this.userData.addresseeEmailRequired) {
            this.signInForm.get('email').setValidators([Validators.required, this.signInForm.get('email').validator]);
        }
        if (this.userData.addresseePhoneRequired) {
            this.signInForm.get('phone').setValidators([Validators.required]);
        }
        this.signInForm.updateValueAndValidity();

    }

    initMap() {
        this.registerMapCallback();
        this.addMapScript();
    }

    registerMapCallback() {
        window.initMap = () => {
            const userCoords = {lat: this.userData.lat,lng: this.userData.long};
            const map = new google.maps.Map(document.getElementById("map"), {
                zoom: 16,
                center: userCoords,
            });
            const marker = new google.maps.Marker({
                position: userCoords,
                map: map,
            });
        }
    }

    addMapScript() {
        let script = document.createElement('script');
        // script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBJcCOgH1MgyzG4XkzU6muNWvIOJq6Kl7w&callback=initMap&libraries=&v=weekly`;

        script.src = `https://maps.googleapis.com/maps/api/js?key=`+environment.GOOGLE_MAPS_API_KEY+`&callback=initMap&libraries=&v=weekly`;
        script.async = true;
        document.body.appendChild(script);
    }
}
